import { createApiSlice } from "@common";
import { CRUD_SENIORITY_LEVEL } from "@routes";

const apiConfig = [
  {
    name: "addSeniorityLevel",
    method: "post",
    url: CRUD_SENIORITY_LEVEL,
    stateKey: "message"
  },
  {
    name: "getSeniorityLevel",
    method: "get",
    url: CRUD_SENIORITY_LEVEL,
    stateKey: "data"
  },
  {
    name: "updateSeniorityLevel",
    method: "put",
    url: CRUD_SENIORITY_LEVEL,
    stateKey: "message"
  },
  {
    name: "deleteSeniorityLevel",
    method: "delete",
    url: CRUD_SENIORITY_LEVEL,
    stateKey: "message"
  },
];

const customReducers = {
  initialState: { data: [], additionalData: [] },
  reducers: {
    setAdditionalData: (state, action) => { state.additionalData = action.payload; },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "seniorityLevel",
  apiConfig,
  customReducers);
const seniorityLevelSlice = slice;

export default seniorityLevelSlice.reducer;

export const {
  addSeniorityLevel,
  getSeniorityLevel,
  updateSeniorityLevel,
  deleteSeniorityLevel
} = thunks;
export const { rowSelect } = actions;
